import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Toast } from "../../../CustomComponent/toast";
import StepRoutes from "../../../Routes/steps_routes";
import CustomInput from "../../../CustomComponent/custom_input";
import FormSubmitButton from "../../../Components/layouts/formSubmitButton";
import SimpleButton from "../../../Components/layouts/simple_button";
import performRequest from "../../../api/request";
import { Form, Formik } from "formik";
import Footer from "../../../Components/Footer/footer";
import { useSelector } from "react-redux";
import LoadingPage from "../../../Components/layouts/loading";
import CustomTextArea from "../../../CustomComponent/custom_textarea";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { FcBusinessman, FcEngineering, FcProcess } from "react-icons/fc";
import CustomSelect from "../../../CustomComponent/custom_select";
import { conceptInfo } from "../../../SchemaInfo/info";
import { conceptSchema } from "../../../Schemas/Media And Marketing/concept_ideas.schema";
// import { informativeVideoInfo } from "../../../SchemaInfo/info";
// import { informativeVideoSchema } from "../../../Schemas/Media And Marketing/informative_video.schema";

const AddConceptIdeas = () => {
  const store = useSelector((store) => store.login.user);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handelSubmit = (values) => {
    performRequest("POST", `/ideas/create-conceptIdea`, values)
      .then((res) => {
        if (res.status === 201) {
          Toast("success", "Concept / Idea created successfully!");
          navigate(`/all-concept-ideas`);
        } else {
          Toast("error", "Error while creating concept / idea details");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  };

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title mb-1">
                  <FcProcess></FcProcess> Concept & Ideas
                </h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
            </div>
          </div>
          <div className="card my-4">
            <div className="card-header">
              <h2 className="page-title">Add Concept & Ideas</h2>
            </div>
            <Formik
              initialValues={conceptInfo}
              validationSchema={conceptSchema}
              onSubmit={handelSubmit}
              enableReinitialize={true}
            >
              {(props) => (
                <Form>
                  <div className="card-body">
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Branding Assets
                      </label>
                      <div className="w-100 col">
                        <CustomSelect
                          name="brandingAsset"
                          className="form-control"
                        >
                          <option value="">Select</option>
                          <option value="Kryzen Biotech">
                            Kryzen Biotech{" "}
                          </option>
                          <option value="Hydroponic Masterclass">
                            Hydroponic Masterclass
                          </option>
                          <option value="Sudhir Devkar">Sudhir Devkar</option>
                          <option value="Eat Pure Greens">
                            Eat Pure Greens
                          </option>
                        </CustomSelect>

                        {props.touched.brandingAsset &&
                          props.errors.brandingAsset && (
                            <p className="text-danger">
                              {" "}
                              {props.errors.brandingAsset}{" "}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3 ">Heading</label>
                      <div className="w-100 col">
                        <CustomInput
                          type="text"
                          className="form-control"
                          name="heading"
                        ></CustomInput>
                        {props.touched.heading && props.errors.heading && (
                          <p className="text-danger">
                            {" "}
                            {props.errors.heading}{" "}
                          </p>
                        )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Sub Heading
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          type={"text"}
                          className="form-control"
                          name="subHeading"
                        ></CustomInput>
                        {props.touched.subHeading &&
                          props.errors.subHeading && (
                            <p className="text-danger">
                              {" "}
                              {props.errors.subHeading}{" "}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">Reference</label>
                      <div className="w-100 col">
                        <CustomInput
                          type="text"
                          className="form-control"
                          name="reference"
                        ></CustomInput>
                        {props.touched.reference && props.errors.reference && (
                          <p className="text-danger">
                            {" "}
                            {props.errors.reference}{" "}
                          </p>
                        )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">CTA Text</label>
                      <div className="w-100 col">
                        <CustomTextArea
                          type="text"
                          className="form-control"
                          name="ctaText"
                        ></CustomTextArea>
                        {props.touched.ctaText && props.errors.ctaText && (
                          <p className="text-danger">
                            {" "}
                            {props.errors.ctaText}{" "}
                          </p>
                        )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Sub CTA Text
                      </label>
                      <div className="w-100 col">
                        <CustomTextArea
                          type="text"
                          className="form-control"
                          name="subCtaText"
                        ></CustomTextArea>
                        {props.touched.subCtaText &&
                          props.errors.subCtaText && (
                            <p className="text-danger">
                              {" "}
                              {props.errors.subCtaText}{" "}
                            </p>
                          )}
                      </div>
                    </div>
                  </div>
                  <div className="card-footer">
                    <div className="btn-list justify-content-end">
                      <FormSubmitButton buttonText="Create Concept & Ideas" />
                      <SimpleButton buttonText="Cancel" type="secondary" />
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};
export default AddConceptIdeas;
